import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  ContentChild,
  Directive,
  ElementRef, HostBinding,
  Input,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  FormGroupConfigService,
  FormGroupDisplayType,
  FormGroupOrientationConfigType
} from "./form-group-config.service";

@Component({
  standalone: false,
  selector: 'p-form-group',
  host: {
    'class': 'form-group',
    '[class.row]': 'isHorizontal && !containsCheckControl'
  },
  templateUrl: './form-group.component.html',
  styleUrls: ['./form-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormGroupComponent{

  @Input() label: string;
  @Input() orientation: FormGroupDisplayType;
  @Input() orientationConfig: FormGroupOrientationConfigType;

  @ContentChild('FormGroupControlInput', { static: false }) ctrl;

  _id: string = null;
  get id() {
    return this._id;
  }
  set id(value: string) {
    this._id = value;
    this.cd.markForCheck();
  }

  get isHorizontal(){
    return this.orientation === FormGroupDisplayType.Horizontal;
  }

  get containsCheckControl(){
    return this.ctrl && this.ctrl.isCheckControl;
  }

  constructor(cfg: FormGroupConfigService, private cd: ChangeDetectorRef){
    this.label = '';
    this.orientation = cfg.orientation;
    this.orientationConfig = cfg.orientationConfig;
  }
}

@Directive({
  standalone: false,
  selector: 'input[pFormControlInput], select[pFormControlInput], textarea[pFormControlInput]',
  exportAs: 'pFormControlInput',
  host: {
    '[class.form-control]': '!isCheckControl',
    '[class.form-check-input]': 'isCheckControl'
  },
  providers: [{provide: 'FormGroupControlInput', useExisting: FormGroupControlInput}],
})
export class FormGroupControlInput implements OnChanges{

  @Input() @HostBinding() id: string;

  get isCheckControl() : boolean {
    return (this.el.nativeElement
      && (this.el.nativeElement.type === 'checkbox'
        || this.el.nativeElement.type === 'radio')
    );
  }

  constructor(private formGroup: FormGroupComponent, private el: ElementRef){ }

  ngOnChanges(c: SimpleChanges){
    if(c.id && c.id.currentValue){
      this.formGroup.id = c.id.currentValue;
    }
  }
}
